import {useInjection} from "inversify-react";
import React, {useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {NewsSectionApi, NewsSectionCreateDto, NewsSectionDto, NewsSectionUpdateDto} from "../../api";
import {Layout, message} from "antd";
import NewsSectionForm from "./newsSectionForm";
import styles from "./newsSection.module.scss";

export default function NewsSectionsListContainer() {
    const apiService = useInjection(ApiService);
    const [news, setNews] = useState<NewsSectionDto | null>(null)

    useEffect(() => {
        getContent();
    }, [])

    const getContent = async () => {
        try {
            const NewsSections = await apiService.getApi(NewsSectionApi).apiNewsSectionIdGet(1);
            setNews(NewsSections.data);
        } catch (e: any) {
            console.log(e.response.data);
        }
    }

    const onSubmit = async (values: NewsSectionCreateDto | NewsSectionUpdateDto) => {
        try {
            await apiService.getApi(NewsSectionApi).apiNewsSectionIdPut(1, values);
            message.success("Dane zapisane poprawnie.", 2);
        } catch (e: any) {
            message.error("Wystąpił błąd.", 2);
            return e.response.data;
        }
    }

    return <>
        <h1>Aktualności Beefteki</h1>
        <Layout style={{backgroundColor: "white", maxWidth: "800px"}}>
            <NewsSectionForm
                initialValues={news}
                onSubmit={onSubmit}
            />
        </Layout>
    </>
}
